var map = {
	"./1.png": 3491,
	"./2.png": 7880,
	"./3.png": 9009,
	"./4.png": 526,
	"./5.png": 3671,
	"./6.png": 6092,
	"./7.png": 2005,
	"./dhl.png": 4850,
	"./discord.png": 1786,
	"./foot.png": 5548,
	"./fuhao.png": 5623,
	"./gift.png": 6298,
	"./kuang-tese.png": 6184,
	"./logo.png": 6537,
	"./lunbo-0.png": 9505,
	"./lunbo-1.png": 6792,
	"./tw.png": 6195,
	"./youtube.png": 9325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1459;